<!-- src/routes/ai-lift.svelte -->
<script>
  import { onMount } from 'svelte';
  import { set_meta } from '../lib/seo.js';
  import RealityCheck from '../components/sections/RealityCheck.svelte';
  import WhyItStalls from '../components/sections/WhyItStalls.svelte';

  onMount(() => {
    set_meta({
      title: 'The AI LIFT — How We Do It',
      description: "The down-to-earth way to put AI to work: a real conversation about your business, the easy wins first, the high-ROI moves, then a plan to make it happen — in plain English.",
      path: '/ai-lift'
    });
  });
</script>

<main class="rc_page">
  <header class="rc_hero">
    <div class="container">
      <h1 class="marker-font">The down-to-earth way to put AI to work.</h1>
      <p>
        No jargon, no 80-slide deck. A real conversation about your business, the
        easy wins first, then the moves that actually pay off — and a plan to make it so.
      </p>
    </div>
  </header>

  <RealityCheck full={true} />
  <WhyItStalls />
</main>

<style>
  .rc_hero {
    background: var(--color-background);
    padding: 6rem 0 1rem;
    text-align: center;
  }

  .container {
    max-width: 820px;
    margin: 0 auto;
    padding: 0 2rem;
  }

  .rc_hero h1 {
    font-size: 3rem;
    line-height: 1.15;
    color: var(--color-text);
    margin: 0 0 1.25rem;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  }

  .rc_hero p {
    font-size: 1.3rem;
    line-height: 1.6;
    color: var(--color-text-muted);
    margin: 0;
  }

  @media (max-width: 768px) {
    .rc_hero {
      padding: 4rem 0 0.5rem;
    }

    .rc_hero h1 {
      font-size: 2.1rem;
    }

    .rc_hero p {
      font-size: 1.1rem;
    }
  }
</style>
